import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Bridge Icon Style 01 - Device Hub (Material Symbol)
 * Bridges are always shown as "active" (purple) - they don't have ON/OFF state
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:device_hub
 */
export const Style01_DeviceHub: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-purple-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      device_hub
    </span>
  );
};

export default Style01_DeviceHub;
